<section
    class="transition-all overflow-hidden duration-200 ease-linear flex flex-col gap-4"
    [class.max-h-0]="!isAdvancedOptionsOpen()"
    [class.max-h-96]="isAdvancedOptionsOpen()"
    [class.mt-4]="isAdvancedOptionsOpen()">
    <section class="flex-1">
        <h1 class="!text-sm">
            {{ 'period' | transloco }}
            <span
                class="text-xs font-normal italic"
                [class.text-custom-blue]="formGroup().controls.startDate.value"
                [class.text-custom-extra-dark-grey]="!formGroup().controls.startDate.value"
                >{{ (formGroup().controls.startDate.value ? 'active' : 'inactive') | transloco }}</span
            >
        </h1>
        <div class="flex flex-row">
            <mat-form-field>
                <mat-label> {{ 'period' | transloco }}</mat-label>
                <mat-date-range-input
                    class="flex flex-row"
                    [formGroup]="formGroup()"
                    [rangePicker]="picker">
                    <input
                        class="flex-1"
                        formControlName="startDate"
                        matInput
                        matStartDate
                        [placeholder]="'startDate' | transloco" />
                    <input
                        class="flex-1"
                        formControlName="endDate"
                        matEndDate
                        matInput
                        [placeholder]="'endDate' | transloco" />
                </mat-date-range-input>
                @if (formGroup().controls.startDate.value) {
                    <fa-icon
                        class="text-custom-dark-grey cursor-pointer"
                        matIconSuffix
                        [icon]="['fas', 'xmark']"
                        (click)="clearDateRange()" />
                }

                <mat-datepicker-toggle
                    matIconSuffix
                    [for]="picker">
                    <fa-icon
                        class="text-blue-500"
                        matDatepickerToggleIcon
                        [icon]="['fas', 'calendar-week']" />
                </mat-datepicker-toggle>
                <mat-date-range-picker #picker />
            </mat-form-field>
        </div>
    </section>
    <section class="flex flex-row gap-4">
        <section class="flex-1">
            <h1 class="!text-sm">
                {{ 'assignedPerson' | transloco }}
                <span
                    class="text-xs font-normal italic"
                    [class.text-custom-blue]="formGroup().controls.assignedPeoples.value.length"
                    [class.text-custom-extra-dark-grey]="!formGroup().controls.assignedPeoples.value.length"
                    >{{ (formGroup().controls.assignedPeoples.value.length ? 'active' : 'inactive') | transloco }}</span
                >
            </h1>
            <div class="flex flex-row">
                <app-select
                    [isMultiSelect]="true"
                    [options]="operatorOptions()"
                    (optionSelected)="selectAssignedPeopleOption($event)" />
            </div>
        </section>
        <section class="flex-1">
            <h1 class="!text-sm">
                {{ 'peopleInvolved' | transloco }}
                <span
                    class="text-xs font-normal italic"
                    [class.text-custom-blue]="formGroup().controls.intervenedPeoples.value.length"
                    [class.text-custom-extra-dark-grey]="!formGroup().controls.intervenedPeoples.value.length"
                    >{{
                        (formGroup().controls.intervenedPeoples.value.length ? 'active' : 'inactive') | transloco
                    }}</span
                >
            </h1>
            <div class="flex flex-row">
                <app-select
                    [isMultiSelect]="true"
                    [options]="intervenedOperatorOptions()"
                    (optionSelected)="selectIntervenedPeopleOption($event)" />
            </div>
        </section>
    </section>
    <section class="flex flex-row gap-4">
        <section class="flex-1">
            <h1 class="!text-sm">
                {{ 'usedForms' | transloco }}
                <span
                    class="text-xs font-normal italic"
                    [class.text-custom-blue]="formGroup().controls.forms.value.length"
                    [class.text-custom-extra-dark-grey]="!formGroup().controls.forms.value.length"
                    >{{ (formGroup().controls.forms.value.length ? 'active' : 'inactive') | transloco }}</span
                >
            </h1>
            <div class="flex flex-row">
                <app-select
                    [isMultiSelect]="true"
                    [options]="assignedFormOptions()"
                    (optionSelected)="selectFormOption($event)" />
            </div>
        </section>
        <section class="flex-1">
            <h1 class="!text-sm">{{ 'updatedEntities' | transloco }}</h1>
            <div
                class="flex items-center gap-2 cursor-pointer"
                (click)="toggleUpdatedEntities()">
                <app-checkbox
                    [checkboxState]="
                        formGroup().controls.includeUpdatedEntities.value
                            ? CheckboxState.CHECKED
                            : CheckboxState.UNCHECKED
                    " />

                <span>{{
                    (formGroup().controls.includeUpdatedEntities.value ? 'include' : 'dontInclude') | transloco
                }}</span>
            </div>
        </section>
    </section>
</section>
